import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label as UiLabel } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function LocationsEditor({ value, onChange }) {
  const [sites, setSites] = useState([]);
  const [known, setKnown] = useState([]);
  useEffect(() => {
    api.get("/sites").then((r) => setSites(r.data)).catch(() => {});
    api.get("/maint/locations").then((r) => setKnown(r.data)).catch(() => {});
  }, []);
  const rows = value || [];
  const upd = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div data-testid="prat-locations">
      <UiLabel>Cabinets et pièces associés</UiLabel>
      <p className="mt-0.5 text-xs text-gray-400">Le nom de la pièce doit correspondre au champ « Pièce » des appareils dans Parc & Maintenance.</p>
      <datalist id="known-pieces">{known.map((k) => <option key={`${k.site_id}-${k.piece}`} value={k.piece} />)}</datalist>
      <div className="mt-2 space-y-2">
        {rows.map((r, i) => (
          <div key={i} className="rounded-2xl border border-gray-100 p-2.5" data-testid={`prat-loc-${i}`}>
            <div className="flex gap-2">
              <Select value={r.site_id || "all"} onValueChange={(v) => upd(i, "site_id", v === "all" ? null : v)}>
                <SelectTrigger data-testid={`prat-loc-site-${i}`} className="w-36 shrink-0 rounded-xl"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Tous les sites</SelectItem>
                  {sites.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
                </SelectContent>
              </Select>
              <Input data-testid={`prat-loc-piece-${i}`} list="known-pieces" value={r.piece || ""} onChange={(e) => upd(i, "piece", e.target.value)} placeholder="Ex. : Cabinet 1" className="rounded-xl" />
              <button type="button" aria-label="Retirer" data-testid={`prat-loc-remove-${i}`} onClick={() => onChange(rows.filter((_, j) => j !== i))} className="rounded-lg p-2 text-gray-400 hover:bg-rose-50 hover:text-rose-600"><Trash2 className="h-4 w-4" /></button>
            </div>
            <label className="mt-2 flex items-center gap-2 text-xs text-gray-600">
              <input type="checkbox" data-testid={`prat-loc-shared-${i}`} checked={!!r.shared} onChange={(e) => upd(i, "shared", e.target.checked)} className="accent-[#065F46]" />
              Pièce commune (ex. salle de radiologie, stérilisation)
            </label>
          </div>
        ))}
      </div>
      <button type="button" data-testid="prat-loc-add" onClick={() => onChange([...rows, { site_id: sites[0]?.id || null, piece: "", shared: false }])}
        className="mt-2 flex items-center gap-1.5 text-sm font-semibold text-[#065F46] hover:underline"><Plus className="h-4 w-4" />Ajouter un cabinet ou une pièce</button>
    </div>
  );
}
